/**
 * Simple window wrapper class to avoid having to do coercions everytime we do window access.
 * Also adds type assignment for window property access.
 */
class WindowWrapper {
  get<T>(property: string) {
    // Coerce window to avoid type errors: https://stackoverflow.com/a/30740935/7632872
    return (window as any)[property] as unknown as T;
  }

  set(property: string, value: any) {
    return ((window as any)[property] = value);
  }
}

export default new WindowWrapper();
